import { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useAuth } from '../../auth/context/AuthContext';
import logo from './logosafite2.png';
import { Dropdown } from 'react-bootstrap';

const NavBar = ({ showNav }) => {
    const { logout } = useAuth();
    const location = useLocation();
    const [activeLink, setActiveLink] = useState('');

    useEffect(() => {
        setActiveLink(location.pathname || '');
    }, [location]);

    return (
        <div className={showNav ? 'sidenav active' : 'sidenav'}>
            {/* ================= LOGO ================= */}
            <div className="logo-container">
                <img src={logo} alt="logo SAFITE" className="logo" />
            </div>

            {/* ================= ENLACES Y DROPDOWNS ================= */}
            <div className="nav flex-column nav-pills">
                {/* Enlace “Inicio” */}
                <Link
                    to="/inicio"
                    className={`nav-link ${
                        activeLink === '/inicio' || activeLink === '/' ? 'active' : ''
                    }`}
                >
                    <span className="material-icons">home</span>
                    <strong> Inicio</strong>
                </Link>

                {/* Enlace “Usuarios” */}
                <Link
                    to="/usuarios"
                    className={`nav-link ${
                        activeLink.startsWith('/usuarios') ? 'active' : ''
                    }`}
                >
                    <span className="material-icons">person</span>
                    <strong> Usuarios</strong>
                </Link>

                {/* Dropdown “Empresas” */}
                <div className="dropdown-wrapper">
                    <Dropdown>
                        <Dropdown.Toggle
                            id="dropdown-empresas"
                            className={`nav-link ${
                                activeLink.startsWith('/empresas') || activeLink.startsWith('/host')
                                    ? 'active'
                                    : ''
                            }`}
                        >
                            <span className="material-icons">apartment</span>
                            <strong> Empresas</strong>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item
                                as={Link}
                                to="/empresas"
                                className={`${activeLink === '/empresas' ? 'active' : ''}`}
                            >
                                <strong>Empresas</strong>
                            </Dropdown.Item>
                            <Dropdown.Item
                                as={Link}
                                to="/host"
                                className={`${activeLink === '/host' ? 'active' : ''}`}
                            >
                                <strong>Host</strong>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                {/* Dropdown “Encuestas” */}
                <div className="dropdown-wrapper">
                    <Dropdown>
                        <Dropdown.Toggle
                            id="dropdown-encuestas"
                            className={`nav-link ${
                                activeLink.startsWith('/encuestas') || activeLink.startsWith('/temas') || activeLink.startsWith('/tipo-pregunta') || activeLink.startsWith('/tipo-dato') || activeLink.startsWith('/preguntas') || activeLink.startsWith('/respuestas')
                                    ? 'active'
                                    : ''
                            }`}
                        >
                            <span className="material-icons">format_list_bulleted</span>
                            <strong> Encuestas</strong>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item
                                as={Link}
                                to="/encuestas"
                                className={`${activeLink === '/encuestas' ? 'active' : ''}`}
                            >
                                <strong>Encuestas</strong>
                            </Dropdown.Item>
                            <Dropdown.Item
                                as={Link}
                                to="/temas"
                                className={`${activeLink === '/temas' ? 'active' : ''}`}
                            >
                                <strong>Temas</strong>
                            </Dropdown.Item>
                            <Dropdown.Item
                                as={Link}
                                to="/tipo-pregunta"
                                className={`${activeLink === '/tipo-pregunta' ? 'active' : ''}`}
                            >
                                <strong>Tipos Pregunta</strong>
                            </Dropdown.Item>
                            <Dropdown.Item
                                as={Link}
                                to="/tipo-dato"
                                className={`${activeLink === '/tipo-dato' ? 'active' : ''}`}
                            >
                                <strong>Tipos Dato</strong>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                {/* Dropdown "OnRoad" */}
                <div className="dropdown-wrapper">
                    <Dropdown>
                        <Dropdown.Toggle
                            id="dropdown-onroad"
                            className={`nav-link ${
                                activeLink.startsWith('/manifiestos')
                                    ? 'active'
                                    : ''
                            }`}
                        >
                            <span className="material-icons">local_shipping</span>
                            <strong> OnRoad</strong>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item
                                as={Link}
                                to="/manifiestos"
                                className={`${activeLink === '/manifiestos' ? 'active' : ''}`}
                            >
                                <strong>Manifiestos</strong>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                {/* Botón “Cerrar Sesión” */}
                <button
                    className="btn btn-danger logout-button"
                    onClick={logout}
                >
                    <span className="material-icons">power_settings_new</span>
                    <strong> Cerrar Sesión</strong>
                </button>
            </div>
        </div>
    );
};

export default NavBar;
